var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$msal.signOut()}}},[_vm._v("logout")])
}
var staticRenderFns = []

export { render, staticRenderFns }